export default __webpack_public_path__ + "static/media/history_slide_1.25b54058.jpg";